import React, { useEffect, useContext, useState, Fragment, useRef } from 'react';
import axios from 'axios';

import { LoginContext } from '../../hooks/context/LoginContext';

import Cookies from 'universal-cookie';

import LoadingPage from '../../componentes/ui/LoadingPage';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import Informes from '../../componentes/formulario/informes/Informes';
import { Alert } from '../../componentes/ui/Alert';
import { SRLWrapper } from 'simple-react-lightbox';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import MiSelect from '../../componentes/formulario/MiSelect';
import MiDataTableIncidencias from './MiDataTableIncidencias';
import Button from '../../componentes/ui/Button';
import { Modal } from 'react-bootstrap';
import FormInput from '../../componentes/formulario/FormInput';
import TextArea from '../../componentes/formulario/TextArea';
import { Spinner } from 'react-bootstrap';
import swal from 'sweetalert';
import FormRow from '../../componentes/formulario/FormRow';

import { alertService } from '../../services/alertservice';

import { getTitle, getApiUrl, MiReplaceAll, getAhorayyyymmdd, getAhoraInputDateTimeLocal, encryptData, getDecodedCookie, getNumFromData } from '../../helpers/helperApp';

function Inci(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, confApp, saveConfApp, getConfApp, centroActivo, apiKey, inciIdUsuViewer, inciMinReload } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ dataTableInci, saveDataTableInci ] = useState([]);
    const [ loadingTableInci, saveLoadingTableInci ] = useState(false);
    const [ showModalCrearInci, saveShowModalCrearInci ] = useState(false);
    const [ valModalCentro, saveValModalCentro ] = useState(0);
    const [ valModalFecha, saveValModalFecha ] = useState(getAhoraInputDateTimeLocal());
    const [ valModalDescripcion, saveValModalDescripcion ] = useState('');
    const [ valModalAgente, saveValModalAgente ] = useState(0);
    const [ valModalPrioridad, saveValModalPrioridad ] = useState(0);
    const [ creandoRegistro, saveCreandoRegistro ] = useState(false);
    const [ showModalAddNota, saveShowModalAddNota ] = useState(false);
    const [ notas, saveNotas ] = useState('');
    const [ notaAdd, saveNotaAdd ] = useState('');
    const [ lineaSeleccionada, saveLineaSeleccionada ] = useState();
    const [ countdown, setCountdown ] = useState(null);
    let intervalId;
    const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2} - .+$/;
    let currentMessage = null;
    const chatContainerRef = useRef(null);

    useEffect( () => {                
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{ 
                    document.title = getTitle(confPantalla.config.trad, confPantalla.inci.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);                        
                        init();
                        
                        let frecuenciaReload = null;                        
                        inciMinReload == '' || inciMinReload == '0' ? frecuenciaReload = 1*60*1000 : frecuenciaReload = parseInt(inciMinReload)*60*1000;
                        console.log(inciIdUsuViewer)
                        console.log(getDecodedCookie('id'))
                        if(getDecodedCookie('id') == inciIdUsuViewer){
                            intervalId = setInterval(() => {                         
                                let countdownTimer = 10; 
                                const countdownInterval = setInterval(() => { 
                                    setCountdown(countdownTimer); 
                                    countdownTimer--; 
                                    if (countdownTimer < 0) { 
                                        clearInterval(countdownInterval); 
                                        setCountdown(null); 
                                        loadDatosTableInci();
                                    } 
                                }, 1000);                         
                            }, frecuenciaReload);
                        }
                        
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                                
                    saveLoadedConf(true);
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })                  
        return () =>{
                document.querySelector("body").classList.remove("sidebar-open");
                clearInterval(intervalId);
        } 

    },[confPantalla])

    useEffect(() => { 
        if (showModalAddNota && chatContainerRef.current) { 
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight; 
        } 
    }, [showModalAddNota]);

    const init = async() => {       
       await loadDatosTableInci();
    }

    const loadDatosTableInci = async () => {
        saveLoadingTableInci(true);        
        const data = new FormData();      
        data.append("validacion", apiKey());
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/inci/getIncidencias', data);   
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
            saveDataTableInci([]);
        }else{
            saveDataTableInci(respuesta.data);                  
        }

        saveLoadingTableInci(false);
    }

    const clickBtnCrear = () => {
        // let valDefectoCentro = 0;
        // // Si tenemos centro seleccionado en el select del menú lo establecemos
        // if(centroActivo != '' && centroActivo != '0'){
        //     valDefectoCentro = centroActivo;
        // }
        // // Si solo hay un centro en el select del modal lo seleccionamos por defecto                
        // if(backUpCentrosModal.length == 1){            
        //     valDefectoCentro = backUpCentrosModal[0].value;
        // }        

        saveValModalCentro(0);
        saveValModalFecha(getAhoraInputDateTimeLocal());
        saveValModalDescripcion('');
        saveValModalAgente(0);
        saveValModalPrioridad(0);        
        saveShowModalCrearInci(true);
    }

    const crearRegistroModal = async () => {
        saveCreandoRegistro(true);               

        const data = new FormData();             
        data.append("validacion", apiKey()); 
        data.append("idcen", valModalCentro);       
        data.append("fec", MiReplaceAll(valModalFecha,'T', ' ')+':00');
        data.append("descripcion", valModalDescripcion);
        data.append("idage", valModalAgente);
        data.append("idpri", valModalPrioridad);                
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/inci/createInidencia', data);             
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});
        }else{           
            await loadDatosTableInci();
        }

        saveCreandoRegistro(false);

        saveShowModalCrearInci(false);
    }

    const clickBtnRecargar = async () => {
        await loadDatosTableInci();
    }

    const showAddNota = async(rowData) => {        
        saveNotaAdd('');
        saveLineaSeleccionada(rowData);
        saveNotas(rowData.notas);
        saveShowModalAddNota(true);

    }

    const crearNota = async () => {
        saveCreandoRegistro(true);               

        const data = new FormData();             
        data.append("validacion", apiKey()); 
        data.append("idlin", lineaSeleccionada.id);        
        data.append("notaadd", notaAdd);                
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/inci/createNota', data);             
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});
        }else{           
            await loadDatosTableInci();
        }

        saveCreandoRegistro(false);

        saveShowModalAddNota(false);
    }

    const cerrarNotaSwal = async (rowData) => {          
        swal({
            title: "",
            text: confPantalla.inci.controles.swalcerrarnota.title,
            icon: "warning",
            buttons: {
                cancel : {text: confPantalla.inci.controles.swalcerrarnota.button.cancel.title, className:'btn btn-flat mr-1 btn-outline-danger btnSwalDelete', visible: true},
                confirm : {text: confPantalla.inci.controles.swalcerrarnota.button.confirm.title, className:'btn btn-flat mr-1 btn-outline-success btnSwalSuccess'}
            } 
        }).then(confirmacion => {
            if(confirmacion){
                cerrarNota(rowData); 
            }
        })       
    }

    const cerrarNota = async(rowData) => {
        saveLoadingTableInci(true);

        const data = new FormData();             
        data.append("validacion", apiKey()); 
        data.append("idlin", rowData.id);                               
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/inci/cerrarNota', data);             
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});
        }else{           
            await loadDatosTableInci();
        } 

        saveLoadingTableInci(false); 
    }

    const handleSelectModal= (selectedItem, nameOfComponent, saveData) => {
        if( selectedItem ){
            saveData(selectedItem.value) 
        }else{
            saveData(0)
        }
    }

    const handleInputModal = (e, saveData) => {        
        const { name, value } = e.target;
        saveData(value)       
    }

    return(
    <SRLWrapper>
        <div className="App wrapper">
            <Alert fondo={true} />    
            {
                confPantalla !== undefined
                ?
                    <Fragment>
                        <Menusup 
                            props = { props }
                        />
                        <Sidebar 
                            props = { props }
                        />
                    </Fragment>
                :
                null
            } 
            <div className="content-wrapper">
                <div className="content-header"></div>
                <section className="content">
                {
                    !tieneNivel 
                ?
                    <PermissionRefused
                        traduction={confPantalla.config.trad.components.permissionrefused} 
                    />
                :
                    <Fragment>
                    {
                    loadedConf === true && confPantalla !== undefined
                    ?
                    <Fragment>
                        {
                            getDecodedCookie('id') != inciIdUsuViewer
                            ?
                                <div className='container-fluid mb-3'>
                                    <Informes
                                        select =     { confPantalla.inci.controles.informes.select }
                                        formulario = { {id:0} }
                                        loadReg =    { false }
                                        estadoForm=  { "" } 
                                        traduction=  { confPantalla.config.trad.components }                                
                                    />                            
                                </div>                                              
                            :
                                null
                        }                       
                        <Section titulo={ confPantalla.inci.sectioninci.titulo } icono={ confPantalla.inci.sectioninci.icono } col={ confPantalla.inci.sectioninci.col } wiki={ confPantalla.inci.sectioninci.wiki } >
                            <FormRow clases=''>
                                {
                                    getDecodedCookie('id') != inciIdUsuViewer
                                    ?
                                        <button                                     
                                                id="btncrear"
                                                className={"btn btn-block btn-success mb-3" } 
                                                type="button" 
                                                onClick={ () => clickBtnCrear() } 
                                                disabled={ false }
                                            >
                                                <i className="fal fa-plus pr-1"></i>
                                                {confPantalla.inci.controles.btncrear.title}
                                        </button>
                                    :
                                        null
                                }
                            </FormRow>                        
                            <FormRow clases=''>
                                <div className="d-flex align-items-center w-100">                                     
                                    <div className="flex-grow-1 text-center"> 
                                        <div className="d-inline-block mx-2"> 
                                            <div className="alert alert-danger alertHelp" role="alert"> 
                                                {getNumFromData(dataTableInci, 'alert-danger')}{confPantalla.inci.controles.help.danger.title} 
                                            </div> 
                                        </div> 
                                        <div className="d-inline-block mx-2"> 
                                            <div className="alert alert-warning alertHelp" role="alert"> 
                                                {getNumFromData(dataTableInci, 'alert-warning')}{confPantalla.inci.controles.help.warning.title} 
                                            </div> 
                                        </div> 
                                        <div className="d-inline-block mx-2">
                                            <div className="alert alert-primary alertHelp" role="alert"> 
                                                {getNumFromData(dataTableInci, 'alert-primary')}{confPantalla.inci.controles.help.primary.title} 
                                            </div>
                                        </div>                                         
                                        <div className="d-inline-block mx-2"> 
                                            <button id="btnrefrescar" className="btn btn-primary" type="button" onClick={() => clickBtnRecargar()} disabled={false} style={{marginBottom : '5px'}}> 
                                                <i className="fal fa-sync pr-1"></i> 
                                                {countdown !== null 
                                                ?`${confPantalla.inci.controles.autoreload.title} ${countdown}s` 
                                                : confPantalla.inci.controles.btnrecargar.title} 
                                            </button> 
                                        </div> 
                                    </div> 
                                </div>
                            </FormRow>                             
                            <MiDataTableIncidencias 
                                estadoForm= { "" }
                                formulario={ {id:0} }
                                id={"tableinci"}
                                columnas={confPantalla.inci.controles.datatable.columns}
                                data={dataTableInci}
                                buttons={confPantalla.inci.controles.datatable.buttons}
                                ordering={confPantalla.inci.controles.datatable.ordering}
                                order={confPantalla.inci.controles.datatable.order}
                                searching={confPantalla.inci.controles.datatable.searching}
                                paging={confPantalla.inci.controles.datatable.paging}
                                select={confPantalla.inci.controles.datatable.select}
                                pagelength={confPantalla.inci.controles.datatable.pagelength}
                                saveLoadingTable={ saveLoadingTableInci }
                                loadingTable={loadingTableInci}
                                columnactions={confPantalla.inci.controles.datatable.columnactions.title}
                                linkColumns={confPantalla.inci.controles.datatable.linkColumns}
                                traduction={confPantalla.config.trad.components.datatable}
                                showModalNotas={ showAddNota }
                                cerrarNota={ cerrarNotaSwal }                                                                     
                            />                                
                        </Section>   
                    </Fragment>
                    :
                    <LoadingPage />
                    }
                    </Fragment>
                }
                </section>
            </div>
            <Footer />
            {
            showModalCrearInci
            ?
                <Modal
                    show={showModalCrearInci}
                    onHide={ () => saveShowModalCrearInci(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w"                                             
                > 
                    <Modal.Header closeButton>
                        <h4>{confPantalla.inci.controles.modal.header.title}</h4>
                    </Modal.Header>                         
                    <Modal.Body>
                        <FormRow>
                            <MiSelect  
                                estadoForm=  { "" }
                                val=         { valModalCentro }   
                                loading=     { creandoRegistro ? true : false }
                                id=          { confPantalla.inci.controles.modal.centro.id }    
                                name=        { confPantalla.inci.controles.modal.centro.name }   
                                label=       { confPantalla.inci.controles.modal.centro.label }    
                                placeholder= { confPantalla.inci.controles.modal.centro.placeholder }
                                col=         { confPantalla.inci.controles.modal.centro.col } 
                                isClearable= { confPantalla.inci.controles.modal.centro.isclearable }
                                isSearchable={ confPantalla.inci.controles.modal.centro.issearchable }
                                dataType=    { confPantalla.inci.controles.modal.centro.datatype }
                                data=        { confPantalla.inci.controles.modal.centro.data }
                                required=    { confPantalla.inci.controles.modal.centro.required } 
                                disabled=    { confPantalla.inci.controles.modal.centro.disabled }
                                readOnly =   { confPantalla.inci.controles.modal.centro.readonly }
                                disablethisid={confPantalla.inci.controles.modal.centro.disablethisid}
                                extradata=    {confPantalla.inci.controles.modal.centro.extradata}
                                formulario= { {id:0} }   
                                change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveValModalCentro) }                                
                            />
                            <MiSelect  
                                estadoForm=  { "" }
                                val=         { valModalAgente }   
                                loading=     { creandoRegistro ? true : false }
                                id=          { confPantalla.inci.controles.modal.agente.id }    
                                name=        { confPantalla.inci.controles.modal.agente.name }   
                                label=       { confPantalla.inci.controles.modal.agente.label }    
                                placeholder= { confPantalla.inci.controles.modal.agente.placeholder }
                                col=         { confPantalla.inci.controles.modal.agente.col } 
                                isClearable= { confPantalla.inci.controles.modal.agente.isclearable }
                                isSearchable={ confPantalla.inci.controles.modal.agente.issearchable }
                                dataType=    { confPantalla.inci.controles.modal.agente.datatype }
                                data=        { confPantalla.inci.controles.modal.agente.data }
                                required=    { confPantalla.inci.controles.modal.agente.required } 
                                disabled=    { confPantalla.inci.controles.modal.agente.disabled }
                                readOnly =   { confPantalla.inci.controles.modal.agente.readonly }
                                disablethisid={confPantalla.inci.controles.modal.agente.disablethisid}
                                extradata=    {confPantalla.inci.controles.modal.agente.extradata}
                                formulario= { {id:0} }   
                                change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveValModalAgente) }                                
                            />
                            <MiSelect  
                                estadoForm=  { "" }
                                val=         { valModalPrioridad }   
                                loading=     { creandoRegistro ? true : false }
                                id=          { confPantalla.inci.controles.modal.prioridad.id }    
                                name=        { confPantalla.inci.controles.modal.prioridad.name }   
                                label=       { confPantalla.inci.controles.modal.prioridad.label }    
                                placeholder= { confPantalla.inci.controles.modal.prioridad.placeholder }
                                col=         { confPantalla.inci.controles.modal.prioridad.col } 
                                isClearable= { confPantalla.inci.controles.modal.prioridad.isclearable }
                                isSearchable={ confPantalla.inci.controles.modal.prioridad.issearchable }
                                dataType=    { confPantalla.inci.controles.modal.prioridad.datatype }
                                data=        { confPantalla.inci.controles.modal.prioridad.data }
                                required=    { confPantalla.inci.controles.modal.prioridad.required } 
                                disabled=    { confPantalla.inci.controles.modal.prioridad.disabled }
                                readOnly =   { confPantalla.inci.controles.modal.prioridad.readonly }
                                disablethisid={confPantalla.inci.controles.modal.prioridad.disablethisid}
                                extradata=    {confPantalla.inci.controles.modal.prioridad.extradata}
                                formulario= { {id:0} }   
                                change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveValModalPrioridad) }                                
                            />
                            <FormInput                                                        
                                estadoForm= { "" }
                                value=      { valModalFecha }
                                loading=    { creandoRegistro ? true : false }
                                id=         { confPantalla.inci.controles.modal.fec.id }   
                                type=       { confPantalla.inci.controles.modal.fec.type }  
                                name=       { confPantalla.inci.controles.modal.fec.name }   
                                label=      { confPantalla.inci.controles.modal.fec.label }                                                       
                                placeholder={ confPantalla.inci.controles.modal.fec.placeholder }    
                                col=        { confPantalla.inci.controles.modal.fec.col } 
                                required=   { confPantalla.inci.controles.modal.fec.required }
                                readonly=   { confPantalla.inci.controles.modal.fec.readonly }                                                
                                disabled=   { confPantalla.inci.controles.modal.fec.disabled }
                                change=     { e => handleInputModal(e,saveValModalFecha) }                                 
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                estadoForm= { "" }
                                value=      { valModalDescripcion }
                                loading=    { creandoRegistro ? true : false }
                                id=         { confPantalla.inci.controles.modal.descripcion.id }   
                                type=       { confPantalla.inci.controles.modal.descripcion.type }  
                                name=       { confPantalla.inci.controles.modal.descripcion.name }   
                                label=      { confPantalla.inci.controles.modal.descripcion.label }                                                       
                                placeholder={ confPantalla.inci.controles.modal.descripcion.placeholder }    
                                col=        { confPantalla.inci.controles.modal.descripcion.col } 
                                required=   { confPantalla.inci.controles.modal.descripcion.required }
                                readonly=   { confPantalla.inci.controles.modal.descripcion.readonly }                                                
                                disabled=   { confPantalla.inci.controles.modal.descripcion.disabled }
                                change=     { e => handleInputModal(e, saveValModalDescripcion) }                                
                            />
                        </FormRow>                                                                      
                        {
                            creandoRegistro 
                            ?
                                <div className="text-center">
                                    <Spinner animation="border" />
                                </div>
                            :
                            null
                        }
                        <p className="font-italic text-center">{ confPantalla.inci.controles.modal.required.title }</p> 
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='text-right'>                                                                   
                            <Button 
                                clases={ "" }
                                color={ "success" }  
                                type="button" 
                                icono={ "" }   
                                id=""     
                                texto={confPantalla.inci.controles.modal.btncrearmodal.title}   
                                accion={ () => crearRegistroModal() } 
                                disabled={ creandoRegistro || valModalCentro == 0 || valModalDescripcion == '' || valModalAgente == 0 || valModalPrioridad == 0 || valModalFecha == '' ? true : false }
                            /> 
                            <Button 
                                clases={ "" }
                                color={ "danger" }  
                                type="button" 
                                icono={ "" }   
                                id=""     
                                texto={confPantalla.inci.controles.modal.btncerrarmodal.title}   
                                accion={ () => saveShowModalCrearInci(false) } 
                                disabled={ false }
                            />                                    
                        </div>
                    </Modal.Footer>                            
                </Modal>
            :
                null 
            }
            {
            showModalAddNota
            ?
                <Modal
                    show={showModalAddNota}
                    onHide={ () => saveShowModalAddNota(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w"                                             
                >                                             
                    <Modal.Body>                                                                                               
                        <FormRow>
                            <div className="chat-container container-fluid" ref={chatContainerRef}> 
                                {
                                    notas != ''
                                    ?
                                    notas.split('\n').map((line, index) => {                                                                         
                                        if (regex.test(line)) { 
                                            if (currentMessage) { 
                                                const [date, ...senderRest] = currentMessage.sender.split(' - '); 
                                                const sender = senderRest.join(' - '); 
                                                const body = currentMessage.body.replace(/\n/g, '<br>'); 
                                                currentMessage = { sender: line, body: '' }; 
                                                return ( 
                                                    <div key={index} className="message mb-3"> 
                                                        <div className="sender">
                                                            <span className='ml-1' style={{ fontWeight: 'bold', color: '#212529' }}>{date} - </span>
                                                            {sender} 
                                                        </div> 
                                                        <div className="body" dangerouslySetInnerHTML={{ __html: body }} />
                                                    </div> ); 
                                            } 
                                            currentMessage = { sender: line, body: '' }; 
                                        } else { 
                                            if (currentMessage) { 
                                                currentMessage.body += (currentMessage.body ? '\n' : '') + line; 
                                            } 
                                        } if (index === notas.split('\n').length - 1 && currentMessage) { 
                                            const [date, ...senderRest] = currentMessage.sender.split(' - '); 
                                            const sender = senderRest.join(' - '); 
                                            const body = currentMessage.body.replace(/\n/g, '<br>'); 
                                            return ( 
                                                <div key={index} className="message mb-2"> 
                                                    <div className="sender">
                                                        <span className='ml-1' style={{ fontWeight: 'bold', color: '#212529' }}>{date} - </span>
                                                        {sender} 
                                                    </div> 
                                                    <div className="body" dangerouslySetInnerHTML={{ __html: body }} /> 
                                                </div> ); 
                                        } 
                                        return null;
                                    })
                                    : 
                                    null
                                }
                                </div>
                        </FormRow>                            
                        {
                            creandoRegistro 
                            ?
                                <div className="text-center">
                                    <Spinner animation="border" />
                                </div>
                            :
                            null
                        }
                        {/* <hr data-content={confPantalla.inci.controles.modalnotas.notasadd.label} style={{marginBottom: '0px'}} className="hr-titleinfwhite"></hr> */}
                        <FormRow>
                            <TextArea                                                        
                                estadoForm= { '' }
                                value=      { notaAdd }
                                loading=    { false }
                                id=         { confPantalla.inci.controles.modalnotas.notasadd.id }   
                                name=       { confPantalla.inci.controles.modalnotas.notasadd.name }
                                rows=       { confPantalla.inci.controles.modalnotas.notasadd.rows }      
                                label=      { confPantalla.inci.controles.modalnotas.notasadd.label }                                                       
                                placeholder={ confPantalla.inci.controles.modalnotas.notasadd.placeholder }    
                                col=        { confPantalla.inci.controles.modalnotas.notasadd.col } 
                                required=   { confPantalla.inci.controles.modalnotas.notasadd.required }
                                readonly=   { confPantalla.inci.controles.modalnotas.notasadd.readonly }                                                
                                disabled=   { confPantalla.inci.controles.modalnotas.notasadd.disabled }
                                change=     { e => handleInputModal(e, saveNotaAdd) }
                                onBlur=     {null} 
                            />
                        </FormRow>
                        <Button 
                            clases={ "btn-block mb-1" }
                            color={ "success" }  
                            type="button" 
                            icono={ "" }   
                            id=""     
                            texto={confPantalla.inci.controles.modalnotas.btncrearmodal.title}   
                            accion={ () => crearNota() } 
                            disabled={ notaAdd == '' ? true : false }
                        />
                        <p className="font-italic text-center">{ confPantalla.inci.controles.modal.required.title }</p> 
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='text-right'>                             
                            <Button 
                                clases={ "" }
                                color={ "danger" }  
                                type="button" 
                                icono={ "" }   
                                id=""     
                                texto={confPantalla.inci.controles.modalnotas.btncerrarmodal.title}   
                                accion={ () => saveShowModalAddNota(false) } 
                                disabled={ false }
                            />                                    
                        </div>
                    </Modal.Footer>                            
                </Modal>
            :
                null 
            }          
        </div>
    </SRLWrapper>
    );
}

export default Inci